import { render } from "./insure-team-bill.vue?vue&type=template&id=80350a9a&scoped=true&ts=true"
import script from "./insure-team-bill.vue?vue&type=script&lang=ts"
export * from "./insure-team-bill.vue?vue&type=script&lang=ts"

import "./insure-team-bill.vue?vue&type=style&index=0&id=80350a9a&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80350a9a"]])

export default __exports__